import { GET_CONNECTIONS, GET_LEDGER_ACCOUNTS } from '../queries';

const refetchQueries = (clientId: string) => [
  {
    query: GET_LEDGER_ACCOUNTS,
    variables: { clientId },
  },
  {
    query: GET_CONNECTIONS,
    variables: { clientId },
  },
];

export default refetchQueries;
